import type { OrderByOption } from '@/store/Store.types';
import type { ArTableViewSort } from '#types/System.Artifacts.types';

export function resolveArTableRowsOrderBy(
  viewSort: ArTableViewSort | null | undefined
): OrderByOption {
  if (!viewSort || viewSort.mode === 'order') {
    return { field: 'order', direction: 'asc' };
  }

  if (viewSort.mode === 'system') {
    return { field: viewSort.key, direction: viewSort.direction };
  }

  return { field: `cells.${viewSort.typeId}.value`, direction: viewSort.direction };
}
